import { useEffect, useState } from "react";
import { gameplay1, gameplay2, gameplay3, gameplay4, gameplay5, gameplay6, player1, player2, player3, player4, player5, player6 } from "../assets";
import { brainwaveServicesIcons } from "../constants";
import {
  Gradient,
  VideoChatMessage
} from "./design/Services";
import Heading from "./Heading";
import Section from "./Section";

const projects = [
  {
    imgSrc1: player2,
    imgAlt1: "Mindfire: Find Us",
    title1: "Level Designer & Game Developer",
    text1: "Programmed the puzzle mechanics and the achievement system, designed the levels.",
    imgSrc2: gameplay2,
    imgAlt2: "Gameplay Mindfire",
    title2: "Mindfire: Find Us",
    text2: "A third-person shooter and strategy game with PSX-era aesthetics. Solve puzzles, manage resources, and use stealth to outsmart heavily armed enemies.",
  },
  {
    imgSrc1: player1,
    imgAlt1: "Raise Dragons and Go to Sleep",
    title1: "PM, Game Design & Development",
    text1: "Managed the team, designed the pokemon-inspired battle mechanics",
    imgSrc2: gameplay1,
    imgAlt2: "Gameplay Raise Dragons",
    title2: "Raise Dragons and Go to Sleep",
    text2: "A medieval farming simulation. The game combines resource management, exploration, and turn-based combat, with a vibrant top-down world.",
  },
  {
    imgSrc1: player3,
    imgAlt1: "Guayabo Eterno",
    title1: "PM, Pixel Artist & Development",
    text1: "Managed the team, designed the pixel art assets, programmed move and dialogues.",
    imgSrc2: gameplay3,
    imgAlt2: "Gameplay Guayabo Eterno",
    title2: "Guayabo Eterno",
    text2: "A pixel art puzzle game set in a time loop. Explore memories, interact with objects, and piece together a polaroid to uncover emotional truths.",
  },
  {
    imgSrc1: player4,
    imgAlt1: "Deep Sky Island",
    title1: "PM, Level Design & Tech Artist",
    text1: "Managed the team, designed the levels and vfx.",
    imgSrc2: gameplay4,
    imgAlt2: "Gameplay Deep Sky Island",
    title2: "Deep Sky Island",
    text2: "An atmospheric exploration game where players collect fuel to activate their jetpack while evading enemies. Navigate the mysterious landscape to reach your spaceship and escape the island's secrets.",
  },
  {
    imgSrc1: player5,
    imgAlt1: "Fast As Food",
    title1: "Level Design & Tech Artist",
    text1: "Designed the levels and objects, customize character and vfx.",
    imgSrc2: gameplay5,
    imgAlt2: "Gameplay Fast As Food",
    title2: "Fast As Food",
    text2: "A dynamic game where players balance their diet by running to consume foods, choosing wisely between healthy options and fast food to avoid becoming their own enemy.",
  },
  {
    imgSrc1: player6,
    imgAlt1: "Ghost Loves Candy",
    title1: "Game Design & Development",
    text1: "Designed the game mechanics, programmed the ghost movement and candy collection.",
    imgSrc2: gameplay6,
    imgAlt2: "Gameplay Ghost Loves Candy",
    title2: "Ghost Loves Candy",
    text2: "An arcade-style game where players control a ghost in the attic, dodging salt while collecting floating candies to achieve high scores.",
  },
];

const Services = () => {
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentProjectIndex((prevIndex) => (prevIndex + 1) % projects.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const currentProject = projects[currentProjectIndex];

  return (
    <Section id="how-to-use">
      <div className="container mb-20">
        <Heading
          title="Game Projects in Detail"
          text="Showcasing the tools, code, and concepts behind my video game creations"
        />

        <div className="relative">
          <div className="relative z-1 grid gap-5 lg:grid-cols-2 ">
            <div className="relative min-h-[39rem] border border-n-1/10 rounded-3xl overflow-hidden hidden lg:block">
              <div className="absolute inset-0">
                <img
                  src={currentProject.imgSrc1}
                  className="h-full w-full object-cover"
                  width={630}
                  height={750}
                  alt={currentProject.imgAlt1}
                />
              </div>

              <div className="absolute inset-0 flex flex-col justify-end p-8 bg-gradient-to-b from-n-8/0 to-n-8/90 lg:p-15">
                <h4 className="h4 mb-4">{currentProject.title1}</h4>
                <p className="body-2 mb-[3rem] text-n-3">
                  {currentProject.text1}
                </p>
              </div>
            </div>

            <div className="p-4 bg-n-7 rounded-3xl overflow-hidden lg:min-h-[46rem]">
              <div className="py-12 px-4 xl:px-8">
                <h4 className="h4 mb-4">{currentProject.title2}</h4>
                <p className="body-2 mb-[2rem] text-n-3">
                  {currentProject.text2}
                </p>

                <ul className="flex items-center justify-between">
                  {brainwaveServicesIcons
                    .filter((_, index) => index !== 2)
                    .map((item, index) => (
                      <li
                        key={index}
                        className="rounded-2xl flex items-center justify-center w-10 h-10 bg-n-6 md:w-15 md:h-15"
                      >
                        <div>
                          <img src={item} width={24} height={24} alt={item} />
                        </div>
                      </li>
                    ))}
                </ul>
              </div>

              <div className="relative h-[20rem] bg-n-8 rounded-xl overflow-hidden md:h-[25rem]">
                <img
                  src={currentProject.imgSrc2}
                  className="w-full h-full object-cover"
                  width={520}
                  height={400}
                  alt={currentProject.imgAlt2}
                />

                <VideoChatMessage />
              </div>
            </div>
          </div>

          <Gradient />
        </div>
      </div>
    </Section>
  );
};

export default Services;